import React from 'react';

import classNames from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Address from '../../components/address';
import { AddressPropType } from '../../prop-types/address';
import LabelWithValue from './label-with-value';
import messages from './messages';
import PackageDetails from './package-details';
import style from './style.module.less';

const ShipmentDetails = ({ shipment }) => {
  const { shippingService, carrierId, packages, shipFrom, shipTo } = shipment;
  return (
    <>
      <div className={classNames(style['header-label'], style.underline)}>
        {!!shipFrom?.warehouseId && (
          <FormattedMessage {...messages.shippingFromHeaderLabel} values={{ shipmentDetailName: shipFrom?.warehouseId }} />
        )}
      </div>
      <div className={style['shipment-details']}>
        <div className={style.header}>
          <FormattedMessage {...messages.shipmentDetailsHeaderLabel} />
        </div>
        <div className={style['shipment-details-grid']}>
          <div className={style['header-label']}>
            <FormattedMessage {...messages.shipmentInfoHeaderLabel} />
          </div>
          <div className={style['header-label']}>
            <FormattedMessage {...messages.shipToHeaderLabel} />
          </div>
          <LabelWithValue label={<FormattedMessage {...messages.carrierTitleLabel} />} value={carrierId ?? '--'} />
          {shipTo ? (
            <Address
              address={{
                ...shipTo,
                line1: shipTo?.street1,
                line2: shipTo?.street2,
                line3: shipTo?.street3,
              }}
            />
          ) : (
            <div>--</div>
          )}
          <LabelWithValue label={<FormattedMessage {...messages.shippingServiceLabel} />} value={shippingService ?? '--'} />
        </div>
        {packages?.length > 0 && packages.map((pack, index) => <PackageDetails key={index} pack={pack} />)}
      </div>
    </>
  );
};

ShipmentDetails.propTypes = {
  shipment: PropTypes.shape({
    carrierId: PropTypes.string,
    packages: PropTypes.array,
    shipFrom: PropTypes.shape({
      warehouseId: PropTypes.string,
    }),
    shipTo: AddressPropType,
    shippingService: PropTypes.string,
  }).isRequired,
};

export default ShipmentDetails;
